<p-dialog
    [visible]="true"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [dismissableMask]="true"
    [closeOnEscape]="true"
    [style]="{ width: '52rem' }"
    [header]="title()"
    (onHide)="onCancel()"
>
    <div class="body">
        <app-form-select
            [control]="entityIdControl"
            [options]="entityOptions()"
            [label]="'packages.pricing.custom.dialog.entity' | translate"
            [placeholder]="'packages.pricing.custom.dialog.entity.placeholder' | translate"
            [filter]="true"
            inputId="customPricingEntity"
            testId="dialog-custom-pricing-entity"
        />

        <div class="tiers-section">
            <h4>{{ 'packages.pricing.custom.dialog.tiers' | translate }}</h4>
            <p class="hint">{{ 'packages.pricing.custom.dialog.tiersHint' | translate }}</p>
            <app-tier-pricing-editor [tiers]="tierFormArray" testId="dialog-custom-pricing-tiers" />
        </div>
    </div>

    <ng-template #footer>
        <p-button
            [label]="'packages.form.cancel' | translate"
            [outlined]="true"
            severity="secondary"
            data-test="dialog-custom-pricing-cancel"
            (onClick)="onCancel()"
        />
        <p-button [label]="'packages.pricing.custom.dialog.save' | translate" data-test="dialog-custom-pricing-save" (onClick)="onSave()" />
    </ng-template>
</p-dialog>
